<template>
  <div class="page-container text-center align-middle wrapper">
    <img id="top_im" src="../assets/icons/404page.svg" class="img-fluid" alt="404 Image" />
    <h3 style="margin-top:2%">Page Not Found!</h3>
    <button id="but1" class="btn btn-primary" @click="goHome">Go Back Home</button>
  </div>
</template>

<script>
export default {
  name: "pagenotfound",
  mounted() {
    this.$store.dispatch("showLoader", false);
  },
  methods: {
    goHome(obj) {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.page-container {
  position: absolute;
  height: 100vh;
  width: 100vw;
  padding: 20vh;
}
#but1 {
  background-color: #24c756;
  border-radius: 4px;
  width: 18%;
  margin-top: 5%;
  font-size: 1.25rem;
  color: #fff;
}

.img-fluid {
  display: block;
  margin: auto;
}

h3 {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 30px;
  color: #24c756;
}
</style>